import advantagesLisence from "@/src/assets/HomePage/Advantages/advantages-lisence.png";
import advantagesAccreditation from "@/src/assets/HomePage/Advantages/advantages-accreditation.png";
import advantagesEducation from "@/src/assets/HomePage/Advantages/advantages-education.png";
import advantagesEuropean from "@/src/assets/HomePage/Advantages/advantages-european.png";

import advantagesSlideEducation from "@/src/assets/HomePage/Advantages/advantages-slide-education.png";
import advantagesSlideDiplom from "@/src/assets/HomePage/Advantages/advantages-slide-diplom.png";
import advantagesSlidePrice from "@/src/assets/HomePage/Advantages/advantages-slide-price.png";
import advantagesSlideOnline from "@/src/assets/HomePage/Advantages/advantages-slide-online.png";
import advantagesSlideSchedule from "@/src/assets/HomePage/Advantages/advantages-slide-schedule.png";
import advantagesSlideSupport from "@/src/assets/HomePage/Advantages/advantages-slide-support.png";
import advantagesSlideCareer from "@/src/assets/HomePage/Advantages/advantages-slide-career.png";

export const AdvantagesCardsConst = [
  {
    name: "Государственная лицензия",
    image: advantagesLisence,
  },
  {
    name: "Государственная и международная аккредитации",
    image: advantagesAccreditation,
  },
  {
    name: "Диплом государственного образца",
    image: advantagesEducation,
  },
  {
    name: "Диплом европейского образца",
    image: advantagesEuropean,
  },
];

export const AdvantagesSliderConst = [
  {
    title: "Образование на английском и русском",
    description:
      "Бакалавриат и магистратура по преподается согласно европейским стандартам, с признанием дипломов в Узбекистане и за рубежом.",
    image: advantagesSlideEducation,
  },
  {
    title: "Программа Двойных дипломов ",
    description: "Получите два международных диплома: от Мальтийской школы медицины и бизнеса одного из ведущих вузов Европы.",
    image: advantagesSlideDiplom,
  },
  {
    title: "Фиксированная цена обучения",
    description: "Фиксированная стоимость на весь период обучения, без скрытых платежей, одна цена на весь срок обучения.",
    image: advantagesSlidePrice,
  },
  {
    title: "Онлайн и очный формат",
    description: "Учитесь на кампусе в Мальте или дистанционно, из любой точки мира.",
    image: advantagesSlideOnline,
  },
  {
    title: "Гибкий или пересональный график",
    description: "Удобно совмещать учёбу с работой или другими занятиями.",
    image: advantagesSlideSchedule,
  },
  {
    title: "Поддержка преподавателей",
    description: "Маленькие группы дают возможность искать персональный подход и наставничество на каждом этапе обучения.",
    image: advantagesSlideSupport,
  },
  {
    title: "Карьерная подготовка",
    description: "Практическое обучение, развитие лидерства, коммуникации и командной работы. ",
    image: advantagesSlideCareer,
  },
];
